import * as React from 'react'

type Props = {
  open: boolean
  onClose: () => void
  title?: React.ReactNode
  body?: React.ReactNode
  primaryLabel?: string
  onPrimary?: () => void
  secondaryLabel?: string
  onSecondary?: () => void
  placement?: 'center' | 'inline'
  width?: number | string
  centerOnParent?: boolean
  theme?: 'light' | 'dark'
}

const PromptModal: React.FC<Props> = ({
  open,
  onClose,
  title,
  body,
  primaryLabel,
  onPrimary,
  secondaryLabel,
  onSecondary,
  placement = 'inline',
  width = 420,
  centerOnParent = false,
  theme = 'light',
}) => {
  if (!open) return null

  const isDark = theme === 'dark'
  const isCenter = placement === 'center'
  const panelStyle: React.CSSProperties = isCenter
    ? centerOnParent
      ? {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 10001,
          width,
          maxWidth: '90vw',
          background: isDark ? '#23272f' : '#fff',
          color: isDark ? '#e6eef8' : '#222',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
          overflow: 'hidden',
        }
      : {
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 10001,
          width,
          maxWidth: '90vw',
          background: isDark ? '#23272f' : '#fff',
          color: isDark ? '#e6eef8' : '#222',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
          overflow: 'hidden',
        }
    : {
        position: 'fixed',
        right: 16,
        bottom: 96,
        zIndex: 10001,
        width,
        maxWidth: '90vw',
        background: isDark ? '#23272f' : '#fff',
        color: isDark ? '#e6eef8' : '#222',
        borderRadius: 12,
        boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
        overflow: 'hidden',
      }

  const overlayStyle: React.CSSProperties = isCenter
    ? centerOnParent
      ? {
          position: 'absolute',
          inset: 0,
          background: 'rgba(0,0,0,0.35)',
          zIndex: 10000,
        }
      : {
          position: 'fixed',
          inset: 0,
          background: 'rgba(0,0,0,0.4)',
          zIndex: 10000,
        }
    : {}

  return (
    <>
      {isCenter && <div style={overlayStyle} onClick={onClose} />}
      <div role='dialog' aria-modal='true' style={panelStyle}>
        {title && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '12px 16px',
              borderBottom: isDark ? '1px solid #444' : '1px solid #eee',
            }}
          >
            <div style={{fontWeight: 600}}>{title}</div>
            <button
              onClick={onClose}
              aria-label='Close'
              style={{
                border: 'none',
                background: 'transparent',
                cursor: 'pointer',
                fontSize: 18,
                lineHeight: 1,
              }}
            >
              <i className='fas fa-times'></i>
            </button>
          </div>
        )}
        {body && <div style={{padding: 16, whiteSpace: 'pre-wrap'}}>{body}</div>}
        {(primaryLabel || secondaryLabel) && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 8,
              padding: '12px 16px',
              borderTop: isDark ? '1px solid #444' : '1px solid #eee',
            }}
          >
            {secondaryLabel && (
              <button
                onClick={onSecondary}
                style={{
                  padding: '8px 12px',
                  borderRadius: 8,
                  border: isDark ? '1px solid #444' : '1px solid #ddd',
                  background: isDark ? '#444' : '#f6f6f6',
                  color: isDark ? '#e6eef8' : '#222',
                  cursor: 'pointer',
                }}
              >
                {secondaryLabel}
              </button>
            )}
            {primaryLabel && (
              <button
                onClick={onPrimary}
                style={{
                  padding: '8px 12px',
                  borderRadius: 8,
                  border: isDark ? '1px solid #2563eb' : '1px solid #0d6efd',
                  background: isDark ? '#2563eb' : '#0d6efd',
                  color: '#fff',
                  cursor: 'pointer',
                }}
              >
                {primaryLabel}
              </button>
            )}
          </div>
        )}
      </div>
    </>
  )
}

export default PromptModal
